<template>
  <base-card>
    <base-question
      :text="
        targetItem.sizes.length > 1
          ? targetItem.type === 'step' ? 'Qual é o valor por tamanho?' : 'Quais são os valores por tamanho?'
          : 'Qual é o valor desse tamanho?'
      "
      class="mb_20"
    />

    <div
      v-for="(size, index) in targetItem.sizes"
      :key="index"
      class="sizes-container"
      :class="{
        'sizes-container--no-border': index === targetItem.sizes.length - 1,
      }"
    >
      <div
        class="sizes-first-row"
        :class="hasPromo[size._id] ? 'sizes-first-row--column' : ''"
      >
        <base-box
          sortBox
          class="size-box"
          :class="
            hasPromo[size._id]
              ? 'full-width'
              : 'mr_15'
          "
        >
          <p>{{ size.name }}</p>
        </base-box>
        <div
          class="price-container size-input"
          :class="
            hasPromo[size._id]
              ? 'full-width'
              : ''
          "
        >
          <base-input
            :label="StringLanguage.value"
            v-model="size.price"
            :money-mask="StringLanguage.currencyConfigs"
            class="size-input"
          />
          <base-input
            v-show="hasPromo[size._id]"
            :label="StringLanguage.promo"
            v-model="size.originalPrice"
            :money-mask="StringLanguage.currencyConfigs"
            class="size-input ml_15"
          />
        </div>
      </div>
      <base-checkbox v-model="hasPromo[size._id]" :checked="hasPromo[size._id]" @click="handlePromoClick(size)">
        <p v-if="targetItem.type !== 'drink'" class="checkbox-area">Este sabor está em promoção neste tamanho</p>
        <p v-else class="checkbox-area">Esta bebida está em promoção neste tamanho</p>
      </base-checkbox>
    </div>
  </base-card>
</template>

<script>
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseInput from "@/components/Input";
import BaseCheckbox from "@/components/Checkbox";
import BaseBox from "@/components/Box";

export default {
  components: {
    BaseCard,
    BaseInput,
    BaseCheckbox,
    BaseQuestion,
    BaseBox,
  },
  data() {
    return {
      hasPromo: {},
    };
  },
  props: {
    targetItem: { default: {} },
  },
  mounted() {
    this.targetItem.sizes.forEach(size => {
      this.hasPromo[size._id] = parseFloat(size.originalPrice) > 0;
    });
  },
  methods: {
    handlePromoClick(size) {
      this.hasPromo = { [size._id]: !this.hasPromo[size._id], ...this.hasPromo };
      size.originalPrice = 0;
    }
  }
};
</script>

<style scoped>
.sizes-container {
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #777777;
  padding-bottom: 25px;
  margin-bottom: 25px;
}
.sizes-container--no-border {
  border-bottom: none;
}
.sizes-first-row {
  display: flex;
  align-items: center;
}
.sizes-first-row--column {
  flex-direction: column;
}
.size-box {
  flex: 1;
  display: flex;
  align-items: center;
  max-height: 45px;
}
.full-width {
  width: 100%;
}
.size-box p {
  color: #aaaaaacc;
  font-size: 1.2em;
}
.size-input {
  flex: 1.25;
}
.price-container {
  display: flex;
  align-items: center;
}
.checkbox-area {
  color: #999999;
  font-size: 12px;
}
</style>